import { CURR_ENV } from '@/core/constants/appConfig/environment';
import { EScriptEnv } from '@/core/constants/appConfig/types';

export const SESSION_ID_KEY =
  CURR_ENV === EScriptEnv.PROD
    ? '_customerReferenceId'
    : `_customerReference${CURR_ENV}Id`;
